import  {add,subtract,multiply,divide,bignumber} from './math.min.js';
	
export function $math(){
  let nums = [];
  for(var i=0;i<arguments.length;i++){
    nums.push(bignumber(arguments[i]));
  }
  return {
    // 加
    add(){
      return add(...nums);
    },
    // 减
    subtract(){
      return subtract(...nums);
    },
    // 乘
    multiply(){
      return multiply(...nums);
    },
    // 除
    divide(){
      return divide(...nums);
    }
  }
}